import TablaConciliacion from "../../../TablaConciliacion";

function TablaAccenorte() {
  return <TablaConciliacion nombreUseCase="ACCENORTE" titulo="ACCENORTE" />;
}

export default TablaAccenorte;
